import React from "react";
import { Input, makeStyles, tokens } from "@fluentui/react-components";

/* global HTMLInputElement */

const useStyles = makeStyles({
  container: {
    position: "relative",
    width: "100%",
    minWidth: "0",
  },
  input: {
    width: "100%",
    minWidth: "0",
    paddingLeft: "12px",
    "::placeholder": {
      color: tokens.colorNeutralForeground4,
    },
  },
  currencySymbol: {
    position: "absolute",
    left: "8px",
    top: "50%",
    transform: "translateY(-50%)",
    color: tokens.colorNeutralForeground1,
    pointerEvents: "none",
    zIndex: 1,
  },
});

interface CurrencyFieldProps {
  value: string | number;
  placeholder?: string;
  required?: boolean;
  disabled?: boolean;
  onChange?: (value: string) => void;
}

const CurrencyField: React.FC<CurrencyFieldProps> = ({
  value,
  placeholder = "0.00",
  required = false,
  disabled = false,
  onChange,
}) => {
  const styles = useStyles();

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value.replace(/[^\d.]/g, "");
    onChange?.(newValue);
  };

  return (
    <div className={styles.container}>
      <span className={styles.currencySymbol}>$</span>
      <Input
        type="text"
        value={`${value || ""}`}
        onChange={handleChange}
        placeholder={placeholder}
        required={required}
        disabled={disabled}
        className={styles.input}
        aria-label={`Currency input ${value || ""}`}
        inputMode="decimal"
      />
    </div>
  );
};

export default CurrencyField;
